import { translator } from 'mage-i18n';
import { createSelector } from 'reselect';

import { appState } from './utils';

export const getEntityTypes = createSelector(appState, translator, ({ entityTypes }, t) => {
  const types = {};
  if (entityTypes && entityTypes.elements) {
    Object.keys(entityTypes.elements).map(countryKey => {
      const entityTypesForCountry = entityTypes.elements[countryKey];
      types[countryKey] = entityTypesForCountry.map(({ type: key, ...rest }) => ({
        ...rest,
        key,
        label: t(`products-fe.options.entity_types.${key}`),
      }));
    });
  }

  return types;
});
